<mat-expansion-panel hideToggle [disabled]="flujo.bloqueado"
    [expanded]="flujos.datosEmpresa.ok && !flujo.ok && !flujo.cargando && !procesoCompleto">
    <mat-expansion-panel-header>
        <mat-panel-title *ngIf="!unSocio">Datos de tus socios(as)</mat-panel-title>
        <mat-panel-title *ngIf="unSocio">Datos socio(a)</mat-panel-title>
        <mat-panel-description>
            <div *ngIf="!flujo.ok && !flujo.cargando && !unSocio && !dosSociosOMasFI">
                <!--======informacion menu ======-->
                Máximo {{cantidadRepresentantesMax}} socios
            </div>
            <div *ngIf="flujo.cargando">
                <div class="spinner-border text-light" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div *ngIf="flujo.ok && !flujo.cargando">
                <!--======ok menu ======-->
                <img src="assets/icons/icon-check.svg" alt="ok" />
            </div>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <app-messages *ngIf="showInfoMessage && contadorSociosIngresados === 0 && flujoNormal" class="advertencia mb-16 p-16"
        message='Ingresa <strong>los datos de él(la) o los(as) socios(as) con poder de firma de tu empresa.</strong> La Cédula de Identidad debe estar vigente (no vencida); de lo contrario, no podrás continuar con el proceso de contratación. '>
    </app-messages>

    <div class="row" *ngIf="contadorSociosIngresados > 0 && flujoNormal">
        <div class="col-md-12 ">
            <div class="socio-ingresado" *ngFor="let representante of listaRepresentantes">
                <!-- crear foreach para mostrar lista obtenida de "getRepresentantes" -->
                <p>Socio(a) : {{ representante.nombre.nombres }} {{ representante.nombre.apellidoPaterno }} {{
                    representante.nombre.apellidoMaterno }} <small *ngIf="representante.correo != null"> [ Email: {{representante.correo}} ]</small></p>
                <div class="status-socio" *ngIf="true">
                    <img src="assets/icons/icon-check.svg" alt="ok">
                    <button class="icon-delete"
                        (click)="modalEliminarSocio(representante)"><i><span>Delete</span></i></button>
                </div>
            </div>
        </div>
    </div>

    <!-- INICIO EVALUACION DE SOCIOS -->
    <ng-container [formGroup]="datosCiForm"
        *ngIf="validarSocio && !ciValidado && contadorSociosIngresados<cantidadRepresentantesMax">
        <div *ngIf="!flujoNormal && (dosSociosFC || unSocio || dosSociosOMasFI)">
            <div style="border-bottom: solid 1px #d8e5eb;">
                <p class="info-datos-socio-casos">Socio(a) administrador(a) y firmante:</p>
                <span *ngIf="!flujoNormal && (dosSociosFC || dosSociosOMasFI)" class="btn-cambiar-socio" (click)="CambiarSocio()"><strong>Cambiar socio(a)</strong>
                <img src="assets/icons/editar.png" alt="">
                </span>
                <p class="info-datos-socio-casos"><b>{{socioEvaluar?.nombre | uppercase}}</b></p>
           </div>                    
            <br><br>
            <app-messages *ngIf="showInfoMessage" class="informativoSS mt-16 mb-16 p-16"
            message='<strong>Importante:</strong> <b>La información de la empresa y de sus socios ha sido verificada por Transbank S.A.</b> en el Registro de Tu Empresa en un Día 
            del Ministerio de Economía, Fomento y Turismo del Gobierno de Chile.'></app-messages>
        </div>
        <div *ngIf="flujoNormal">
            <p class="info-datos-socio">Datos Nuevo Socio(a)</p>
        </div>
        <div class="row ">
            <div class="col-md-6 mt-24">
                <label for="rut">RUT Socio(a)</label>
                <input *ngIf="!flujoNormal" appFormatRut [readonly]="(datosCiForm.get('txtRut') || '') !== ''" type="text" name="txtRut" formControlName="txtRut" id="txtRut"
                    placeholder="Ej: 123456789"
                    [class.inputInvalido]="datosCiForm.get('txtRut').invalid && datosCiForm.get('txtRut').dirty"
                    autocomplete="off">
                <input *ngIf="flujoNormal" appFormatRut type="text" name="txtRut" formControlName="txtRut" id="txtRut"
                placeholder="Ej: 123456789"
                [class.inputInvalido]="datosCiForm.get('txtRut').invalid && datosCiForm.get('txtRut').dirty"
                autocomplete="off">
                <div *ngFor="let validation of messageRescatarDataError.rutSocio">
                    <p *ngIf="datosCiForm.get('txtRut').hasError(validation.type) && (datosCiForm.get('txtRut').dirty || datosCiForm.get('txtRut').touched )"
                        class="mensajeError mb-0">
                        {{ validation.message }}
                    </p>
                </div>
            </div>
            <div class="col-md-6 mt-24 numero-serie" *ngIf="true">
                <label for="txtSerie">Número de serie o documento </label>
                <div class="label-right" (click)="modalCiHelper()">Info &nbsp;<i class="informativo-blue"></i></div>
                <input appFormatSerie type="text" name="txtSerie" formControlName="txtSerie" placeholder="Ej: 100000001"
                    [class.inputInvalido]="datosCiForm.get('txtSerie').invalid && datosCiForm.get('txtSerie').dirty"
                    id="txtSerie" autocomplete="off">
                <div *ngFor="let validation of messageRescatarDataError.serieSocio">
                    <p *ngIf="datosCiForm.get('txtSerie').hasError(validation.type) && (datosCiForm.get('txtSerie').dirty || datosCiForm.get('txtSerie').touched )"
                        class="mensajeError mb-0">
                        {{ validation.message }}
                    </p>
                </div>
            </div>

            <div class="col-md-12 mt-36">
                <button tabindex="5" class="btn-primary-tbk button-float-right" type="submit" value="Validar"
                    (click)="validar($event)" [disabled]="rutControl.invalid || serieControl.invalid">
                    <div *ngIf="loading" class="spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="!loading">Evaluar</div>
                </button>
            </div>
        </div>
    </ng-container>
    <!-- FIN EVALUACION DE SOCIOS -->

     <!-- INICIO SOCIOS SELECCIONABLES -->
   <div class="row" *ngIf="(dosSociosFC || dosSociosOMasFI) && !validarSocio && muestraSociosSelecionables && !unSocio">
    <span *ngIf="dosSociosFC" class="text-seleccion-socio">Selecciona la persona socia quien será el <strong>administrador de la cuenta de la empresa</strong>
        en el Portal de Clientes Transbank. 
        <span><div class="label-cual-socio"  [popper]= "'<p>El(la) socio(a) o representante legal debe tener poder de firma de la empresa.</p>
            <p>Los datos de correo electrónico y RUT se utilizarán para crear la cuenta y serán los datos de ingreso para Portal privado.</p>'" [popperPlacement]="'bottom-end'"
            [popperTrigger]="'click'" [popperHideOnClickOutside]="true" [popperHideOnScroll]="true"
            [popperApplyClass]="'popperstyle-socios'"><span class="cual-socio">¿Cual Socio Selecciono?&nbsp;<i class="informativo-blue"></i></span>
            </div></span>
        
    </span>
    <span class="text-seleccion-socio" *ngIf="dosSociosOMasFI">Selecciona la persona socia quien deberá <strong>firmar la solicitud de afiliación al servicio
        y será el administrador de la cuenta de la empresa</strong> en el Portal de Clientes Transbank.
        <div class="label-left"  [popper]= "'<p>El(la) socio(a) o representante legal debe tener poder de firma de la empresa.</p>
            <p>Los datos de correo electrónico y RUT se utilizarán para crear la cuenta y serán los datos de ingreso para Portal privado.</p>'" [popperPlacement]="'bottom-end'"
            [popperTrigger]="'click'" [popperHideOnClickOutside]="true" [popperHideOnScroll]="true"
            [popperApplyClass]="'popperstyle-socios'"><span class="cual-socio">¿Cual Socio Selecciono?&nbsp;<i class="informativo-blue"></i></span>
            </div>
    </span>
    
    
    <div class="col-md-12 ">
        <div class="socio-ingresado">
            <mat-radio-group class="radio-group" name="socios" [(ngModel)]="socioSeleccionado" (ngModelChange)="actualizarSocioSeleccionado($event)">
                <mat-radio-button *ngFor="let socio of listaSociosEmpresa; index as i" name="socios" [value]="i+1"  style="margin: 10px">
                    <span class="text-lista-socios">Socio(a) N°{{i + 1}}: {{socio.nombre | uppercase}}</span>
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="row box-button">
        <div class="col-md-12">
            <button class="btn-primary-tbk" type="submit" value="irAEvaluacion" (click)="irAEvaluacion()"
                [disabled]="socioSeleccionado == ''">
                <div *ngIf="loading" class="spinner-border text-light" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div *ngIf="!loading">Continuar</div>
            </button>
        </div>
    </div>
</div>
<!-- FIN SOCIOS SELECCIONABLES-->

    <!-- INICIO FORMULARIO DATOS SOCIO -->
    <ng-container [formGroup]="datosSocioForm" *ngIf="ciValidado && contadorSociosIngresados<cantidadRepresentantesMax && !visualizarSocioDosAccordion && formularioPrincipal">
        <div class="row">
            <div class="col-md-12">
                <div class="datos-socios">
                    <div *ngIf="!flujoNormal">
                        <div style="border-bottom: solid 1px #d8e5eb;">
                            <p class="info-datos-socio-casos">Socio(a) administrador(a) y firmante:</p>
                            <span *ngIf="!flujoNormal && (dosSociosFC || dosSociosOMasFI)" class="btn-cambiar-socio" (click)="CambiarSocio()"><strong>Cambiar socio(a)</strong>
                                <img src="assets/icons/editar.png" alt="">
                            </span>
                            <p class="info-datos-socio-casos"><b>{{socioEvaluar?.nombre | uppercase}}</b></p>
                       </div>                    
                    </div>
                    <div *ngIf="flujoNormal">
                        <p class="info-socios-n">Datos Nuevo Socio(a)</p>
                    </div>
                    <ng-container>
                        <div class="row">
                            <div class="col-md-6 mt-36">
                                <label for="run">RUT Socio(a)</label>
                                <input appFormatRut [readonly]="(datosSocioForm.get('run') || '') !== ''" type="text"
                                    name="run" formControlName="run" id="run" placeholder="Ej: 123456789"
                                    autocomplete="off" appMaxLength="12" [class.inputInvalido]="
                                    datosSocioForm.get('run').invalid && 
                                    datosSocioForm.get('run').touched
                                " required />
                                <div *ngFor="let validation of messageRescatarDataError.rutSocio">
                                    <p *ngIf="datosSocioForm.get('run').hasError(validation.type) && (datosSocioForm.get('run').dirty || datosSocioForm.get('run').touched )"
                                        class="mensajeError mb-0">
                                        {{ validation.message }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mt-36">
                                <label for="nombre">Nombre</label>
                                <input appCaracteres [readonly]="
                                    (datosPersonalesResponse?.nombre.nombres || '') !== ''
                                  " type="text" name="nombre" formControlName="nombre" placeholder="Ingresa nombre"
                                    autocomplete="off" appMaxLength="50" [class.inputInvalido]="
                                    datosSocioForm.get('nombre').invalid &&
                                    datosSocioForm.get('nombre').touched
                                  " required />
                                <p *ngIf="
                                    (datosSocioForm.get('nombre').touched &&
                                      datosSocioForm.get('nombre') === null) ||
                                    (datosSocioForm.get('nombre').touched &&
                                      datosSocioForm.get('nombre').invalid)
                                  " class="mensajeError">
                                    {{ mensajeErrorDatosPersonales.REQUIRED_NAME_MESSAGE }}
                                </p>
                            </div>
                            <div class="col-md-6 mt-36">
                                <label for="primerApellido">Primer apellido</label>
                                <input appCaracteres [readonly]="
                                    (datosPersonalesResponse?.nombre.apellidoPaterno || '') !== ''
                                  " type="text" name="primerApellido" formControlName="primerApellido"
                                    placeholder="Ingresa primer apellido" autocomplete="off" appMaxLength="50"
                                    [class.inputInvalido]="
                                    datosSocioForm.get('primerApellido').invalid &&
                                    datosSocioForm.get('primerApellido').touched
                                  " required />
                                <p *ngIf="
                                    (datosSocioForm.get('primerApellido').touched &&
                                      datosSocioForm.get('primerApellido') === null) ||
                                    (datosSocioForm.get('primerApellido').touched &&
                                      datosSocioForm.get('primerApellido').invalid)
                                  " class="mensajeError">
                                    {{ mensajeErrorDatosPersonales.REQUIRED_LASTNAME_MESSAGE }}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mt-36">
                                <label for="segundoApellido">Segundo apellido (opcional)</label>
                                <input appCaracteres [readonly]="
                                    (datosPersonalesResponse?.nombre.apellidoMaterno || '') !== ''
                                  " type="text" name="segundoApellido" formControlName="segundoApellido"
                                    placeholder="Ingresa segundo apellido" appMaxLength="50" autocomplete="off" />
                            </div>
                            <!-- Existen dos DIV de nacionalidad ya que el disabled lógico no lo detecta -->
                            <div class="col-md-6 mt-36">
                                <label for="nacionalidad">Nacionalidad</label>
                                <ng-container
                                    *ngIf="datosPersonalesResponse?.idNacionalidad === 47; else selectHabilitado">
                                    <select name="nacionalidad" formControlName="nacionalidad" disabled>
                                        <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                                            {{ nacionalidad.nombre }}
                                        </option>
                                    </select>
                                </ng-container>
                                <ng-template #selectHabilitado>
                                    <select name="nacionalidad" formControlName="nacionalidad"
                                        [class.selectInvalido]="datosSocioForm.get('nacionalidad').invalid && datosSocioForm.get('nacionalidad').touched"
                                        placeholder="Seleccionar">
                                        <option value="0">Seleccionar</option>
                                        <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                                            {{ nacionalidad.nombre }}
                                        </option>
                                    </select>
                                </ng-template>
                                <p *ngIf="
                                    (datosSocioForm.get('nacionalidad').touched && datosSocioForm.get('nacionalidad') === null) ||
                                    (datosSocioForm.get('nacionalidad').touched && datosSocioForm.get('nacionalidad').invalid)G"
                                    class="mensajeError">
                                    {{ mensajeErrorDatosPersonales.REQUIRED_COUNTRY_MESSAGE }}
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mt-36">
                                <label for="telefono">Teléfono</label>
                                <span class="prefijo">+56</span>
                                <input appNumeros type="text" class="pre-input" name="telefono"
                                    formControlName="telefono" placeholder="Ingresar hasta 9 digitos" autocomplete="off"
                                    appMaxLength="9" [class.inputInvalido]="
                                    datosSocioForm.get('telefono').invalid &&
                                    (datosSocioForm.get('telefono').touched || datosSocioForm.get('telefono').dirty)
                                  " required />
                                <p *ngIf="
                                    (datosSocioForm.get('telefono').touched || datosSocioForm.get('telefono').dirty) &&
                                    ( datosSocioForm.get('telefono').hasError('length') || datosSocioForm.get('telefono').hasError('pattern') )
                                  " class="mensajeError">
                                    {{ mensajeErrorDatosPersonales.INVALID_PHONE_MESSAGE }}
                                </p>
                                <p *ngIf="
                                    (datosSocioForm.get('telefono').touched || datosSocioForm.get('telefono').dirty) &&
                                    datosSocioForm.get('telefono').hasError('required')
                                  " class="mensajeError">
                                    {{ mensajeErrorDatosPersonales.REQUIRED_PHONE_MESSAGE }}
                                </p>
                            </div>
                            <!-- Solicitud de correo a PRIMER representante Legal-->
                            <div *ngIf="!isThereAnEmailRRLL" class="col-md-6 mt-36">
                                <label for="correo">Correo electrónico</label>
                                <div class="label-right" [popper]=mensajeErrorDatosPersonales.ACCOUNT_EMAIL_TOOLTIP [popperPlacement]="'bottom-end'" [popperTrigger]="'hover'" [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperApplyClass]="'popperstyle-blue'">&nbsp;<i class="informativo-blue"></i></div>
                                <input type="text" name="correo"
                                    formControlName="correo" placeholder="Ej: micorreo@mail.com" autocomplete="off"
                                    appMaxLength="50" autocomplete="off" [class.inputInvalido]="
                                    datosSocioForm.get('correo').invalid &&
                                    (datosSocioForm.get('correo').touched || datosSocioForm.get('correo').dirty)
                                  " required />
                                <p *ngIf="
                                    (datosSocioForm.get('correo').touched || datosSocioForm.get('correo').dirty) &&
                                    ( datosSocioForm.get('correo').hasError('pattern') )
                                  " class="mensajeError">
                                    {{ mensajeErrorDatosPersonales.INVALID_EMAIL_MESSAGE }}
                                </p>
                                <p *ngIf="
                                    (datosSocioForm.get('correo').touched || datosSocioForm.get('correo').dirty) &&
                                    datosSocioForm.get('correo').hasError('required')
                                  " class="mensajeError">
                                    {{ mensajeErrorDatosPersonales.REQUIRED_EMAIL_MESSAGE }}
                                </p>
                            </div>
                        </div>
                    </ng-container>
                        <!--<app-messages class="informativo" message="Tienes que validar tu Correo electrónico. Presiona Validar para seguir con el proceso."></app-messages>-->
                  
                        <span *ngIf="showInfoMessage2 && !flujoNormal">
                            <app-messages *ngIf="showInfoMessage2 && !flujoNormal" class="advertencia-verificacion-socio mt-48 mb-16 p-16-0" message='<strong>Por favor, verifica y completa los datos que falten</strong>, los datos de correo electrónico y rut Socio
                                se utilizarán para crear la cuenta en el Portal de Clientes Transbank.'>
                            </app-messages>
                            <div class="label-left"  [popper]= "'<p>Es la plataforma online donde podrás gestionar tus ventas, revisar abonos,
                                acceder a toda la información que necesitas para la operacion de tu empresa y mucho más.</p>'" [popperPlacement]="'bottom-end'"
                            [popperTrigger]="'click'" [popperHideOnClickOutside]="true" [popperHideOnScroll]="true"
                            [popperApplyClass]="'popperstyle-clientes-transbank'"><span class="cual-socio portal-cliente-transbank">¿Qué es el Portal de Clientes Transbank?&nbsp;<i class="informativo-blue"></i></span>
                        </div>
                        </span>
                        
                       
                        <div class="row box-button">
                            <div class="col-md-12">
                                <button class="btn-primary-tbk" type="submit" (click)="Guardar()"
                                    [disabled]="!datosSocioForm.valid && !formChanged">
                                    <div *ngIf="loading && flujoNormal" class="spinner-border text-light" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <div *ngIf="!loading && flujoNormal">Guardar</div>
                                    <div *ngIf="!loading && !flujoNormal">Confirmar</div>
                                </button>
                            </div>
                        </div>
                    
                    <app-messages *ngIf="!isThereAnEmailRRLL && flujoNormal" class="advertencia mt-48 mb-16 p-16" message='Por favor ingrese el correo de un RRLL'>
                        </app-messages>
                    <app-messages *ngIf="showInfoMessage2 && flujoNormal" class="advertencia mt-48 mb-16 p-16" message='Por favor, <strong>verifica y completa los datos que falten</strong>, en caso de que la empresa tenga 
                    más de un socio(a), <strong>el socio(a) que ingrese los datos debe tener 
                    poder de firma.</strong> Puedes ingresar hasta {{cantidadRepresentantesMax}} socios(as).'>
                    </app-messages>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- FIN FORMULARIO DATOS SOCIO -->

      <!--INI ACORDION SOCIOS-->
      <mat-accordion *ngIf="accordionSocios && (dosSociosFC || unSocio || dosSociosOMasFI)" multi>
        <mat-expansion-panel [disabled]="!accordionSocios" [expanded]="panelOpenStateAdmin">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div style="border-bottom: solid 1px #d8e5eb;">
                    <p class="info-datos-socio-casos">Socio(a) administrador(a):</p>
                    <p class="info-datos-socio-casos"><b>{{socioEvaluar?.nombre | uppercase}}</b></p>
                </div>  
              </mat-panel-title>
              <mat-panel-description>
                <div>
                    <!--======ok menu ======-->
                    <img class="img-accordion" src="assets/icons/icon-check.svg" alt="ok" />
                </div>

                </mat-panel-description>
            </mat-expansion-panel-header>
            <!-- INICIO FORMULARIO DATOS SOCIO -->
            <ng-container [formGroup]="datosSocioAdminForm" *ngIf="(dosSociosFC || unSocio || flujoDosSociosOMasFI) && muestraEnAcordion">
                <div class="row">
                    <div class="col-md-12">
                        <div class="datos-socios">
                            <ng-container>
                                <div class="row">
                                    <div class="col-md-6 m-top-36">
                                        <label for="run">RUT Socio(a)</label>
                                        <input appFormatRut [readonly]="(datosSocioAdminForm.get('run') || '') !== ''" type="text"
                                            name="run" formControlName="run" id="run" placeholder="Ej: 123456789"
                                            autocomplete="off" appMaxLength="12" [class.inputInvalido]="
                                            datosSocioAdminForm.get('run').invalid && 
                                            datosSocioAdminForm.get('run').touched
                                        " required />
                                        <div *ngFor="let validation of messageRescatarDataError.rutSocio">
                                            <p *ngIf="datosSocioAdminForm.get('run').hasError(validation.type) && (datosSocioAdminForm.get('run').dirty || datosSocioForm.get('run').touched )"
                                                class="mensajeError mb-0">
                                                {{ validation.message }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 m-top-36">
                                        <label for="nombre">Nombre</label>
                                        <input appCaracteres [readonly]="
                                            (datosPersonalesAdminResponse?.nombre.nombres || '') !== ''
                                        " type="text" name="nombre" formControlName="nombre" placeholder="Ingresa nombre"
                                            autocomplete="off" appMaxLength="50" [class.inputInvalido]="
                                            datosSocioAdminForm.get('nombre').invalid &&
                                            datosSocioAdminForm.get('nombre').touched
                                        " required />
                                        <p *ngIf="
                                            (datosSocioAdminForm.get('nombre').touched &&
                                            datosSocioAdminForm.get('nombre') === null) ||
                                            (datosSocioAdminForm.get('nombre').touched &&
                                            datosSocioAdminForm.get('nombre').invalid)
                                        " class="mensajeError">
                                            {{ mensajeErrorDatosPersonales.REQUIRED_NAME_MESSAGE }}
                                        </p>
                                    </div>
                                    <div class="col-md-6 m-top-36">
                                        <label for="primerApellido">Primer apellido</label>
                                        <input appCaracteres [readonly]="
                                            (datosPersonalesAdminResponse?.nombre.apellidoPaterno || '') !== ''
                                        " type="text" name="primerApellido" formControlName="primerApellido"
                                            placeholder="Ingresa primer apellido" autocomplete="off" appMaxLength="50"
                                            [class.inputInvalido]="
                                            datosSocioAdminForm.get('primerApellido').invalid &&
                                            datosSocioAdminForm.get('primerApellido').touched
                                        " required />
                                        <p *ngIf="
                                            (datosSocioAdminForm.get('primerApellido').touched &&
                                            datosSocioAdminForm.get('primerApellido') === null) ||
                                            (datosSocioAdminForm.get('primerApellido').touched &&
                                            datosSocioAdminForm.get('primerApellido').invalid)
                                        " class="mensajeError">
                                            {{ mensajeErrorDatosPersonales.REQUIRED_LASTNAME_MESSAGE }}
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 m-top-36">
                                        <label for="segundoApellido">Segundo apellido (opcional)</label>
                                        <input appCaracteres [readonly]="
                                            (datosPersonalesAdminResponse?.nombre.apellidoMaterno || '') !== ''
                                        " type="text" name="segundoApellido" formControlName="segundoApellido"
                                            placeholder="Ingresa segundo apellido" appMaxLength="50" autocomplete="off" />
                                    </div>
                                    <!-- Existen dos DIV de nacionalidad ya que el disabled lógico no lo detecta -->
                                    <div class="col-md-6 m-top-36">
                                        <label for="nacionalidad">Nacionalidad</label>
                                        <ng-container
                                        {{datosPersonalesAdminResponse.idNacionalidad | json}}
                                            *ngIf="datosPersonalesAdminResponse?.idNacionalidad === 47; else selectHabilitado">
                                            <select name="nacionalidad" formControlName="nacionalidad" disabled>
                                                <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                                                    {{ nacionalidad.nombre }}
                                                </option>
                                            </select>
                                        </ng-container>
                                        <ng-template #selectHabilitado>
                                            <select name="nacionalidad" formControlName="nacionalidad"
                                                [class.selectInvalido]="datosSocioAdminForm.get('nacionalidad').invalid && datosSocioAdminForm.get('nacionalidad').touched"
                                                placeholder="Seleccionar">
                                                <option value="0">Seleccionar</option>
                                                <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                                                    {{ nacionalidad.nombre }}
                                                </option>
                                            </select>
                                        </ng-template>
                                        <p *ngIf="
                                            (datosSocioAdminForm.get('nacionalidad').touched && datosSocioAdminForm.get('nacionalidad') === null) ||
                                            (datosSocioAdminForm.get('nacionalidad').touched && datosSocioAdminForm.get('nacionalidad').invalid)G"
                                            class="mensajeError">
                                            {{ mensajeErrorDatosPersonales.REQUIRED_COUNTRY_MESSAGE }}
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 m-top-36">
                                        <label for="telefono">Teléfono</label>
                                        <span class="prefijo">+56</span>
                                        <input appNumeros type="text" class="pre-input" name="telefono"
                                            formControlName="telefono" placeholder="Ingresar hasta 9 digitos" autocomplete="off"
                                            appMaxLength="9" [class.inputInvalido]="
                                            datosSocioAdminForm.get('telefono').invalid &&
                                            (datosSocioAdminForm.get('telefono').touched || datosSocioAdminForm.get('telefono').dirty)
                                        " required />
                                        <p *ngIf="
                                            (datosSocioAdminForm.get('telefono').touched || datosSocioAdminForm.get('telefono').dirty) &&
                                            ( datosSocioAdminForm.get('telefono').hasError('length') || datosSocioAdminForm.get('telefono').hasError('pattern') )
                                        " class="mensajeError">
                                            {{ mensajeErrorDatosPersonales.INVALID_PHONE_MESSAGE }}
                                        </p>
                                        <p *ngIf="
                                            (datosSocioAdminForm.get('telefono').touched || datosSocioAdminForm.get('telefono').dirty) &&
                                            datosSocioAdminForm.get('telefono').hasError('required')
                                        " class="mensajeError">
                                            {{ mensajeErrorDatosPersonales.REQUIRED_PHONE_MESSAGE }}
                                        </p>
                                    </div>
                                    <!-- Solicitud de correo a PRIMER representante Legal-->
                                    <div class="col-md-6 m-top-36">
                                        <label for="correo">Correo electrónico</label>
                                        <div class="label-right" [popper]=mensajeErrorDatosPersonales.ACCOUNT_EMAIL_TOOLTIP [popperPlacement]="'bottom-end'" [popperTrigger]="'hover'" [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperApplyClass]="'popperstyle'">&nbsp;<i class="informativo-blue"></i></div>
                                        <input type="text" name="correo"
                                            formControlName="correo" placeholder="Ej: micorreo@mail.com" autocomplete="off"
                                            appMaxLength="50" autocomplete="off" [class.inputInvalido]="
                                            datosSocioAdminForm.get('correo').invalid &&
                                            (datosSocioAdminForm.get('correo').touched || datosSocioAdminForm.get('correo').dirty)
                                        " required />
                                        <p *ngIf="
                                            (datosSocioAdminForm.get('correo').touched || datosSocioAdminForm.get('correo').dirty) &&
                                            ( datosSocioAdminForm.get('correo').hasError('pattern') )
                                        " class="mensajeError">
                                            {{ mensajeErrorDatosPersonales.INVALID_EMAIL_MESSAGE }}
                                        </p>
                                        <p *ngIf="
                                            (datosSocioAdminForm.get('correo').touched || datosSocioAdminForm.get('correo').dirty) &&
                                            datosSocioAdminForm.get('correo').hasError('required')
                                        " class="mensajeError">
                                            {{ mensajeErrorDatosPersonales.REQUIRED_EMAIL_MESSAGE }}
                                        </p>
                                    </div>
                                </div>
                                <!--<app-messages class="informativo" message="Tienes que validar tu Correo electrónico. Presiona Validar para seguir con el proceso."></app-messages>-->
                                <div class="row box-button">
                                    <div class="col-md-12">
                                        <button class="btn-primary-tbk" type="submit" (click)="Guardar()"
                                            [disabled]=true>
                                            <div *ngIf="loading" class="spinner-border text-light" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <div *ngIf="!loading">Guardar</div>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                            <app-messages *ngIf="showInfoMessage2 && dosSociosFC" class="advertencia mt-48 mb-16 p-16" message='Por favor, <strong>verifica y completa los datos que falten</strong>, en caso de que la empresa tenga 
                            más de un socio(a), <strong>el socio(a) que ingrese los datos debe tener 
                            poder de firma.</strong> Puedes ingresar hasta {{cantidadRepresentantesMax}} socios(as).'>
                            </app-messages>
                        </div>
                    </div>
                </div>
            </ng-container>
            <!-- FIN FORMULARIO DATOS SOCIO admin -->
        </mat-expansion-panel>
        <app-messages *ngIf="(dosSociosOMasFI || unSocio) && !dosSociosFC && accordionSocios" class="informativoSS mt-48 mb-16 p-16" message='Luego de crear la cuenta
            en el Portal de Clientes Transbank, podrás agregar o cambiar el socio administrador, en el caso que lo requieras.'>
        </app-messages>

        <div class="row box-button" *ngIf="(dosSociosOMasFI || unSocio) && !dosSociosFC && contadorSociosIngresados > 0">
            <div class="col-md-12">
                <button class="btn-primary-tbk" type="submit" value="ContinuarADeclaracion" (click)="ContinuarADeclaracion()">
                    <div>Continuar</div>
                </button>
            </div>
        </div>

        <mat-expansion-panel *ngIf="dosSociosFC" [expanded]="panelOpenState">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div *ngIf="!flujoNormal">
                        <div style="border-bottom: solid 1px #d8e5eb;">
                            <p class="info-datos-socio-casos">Socio(a) N°2: </p>
                            <b class="info-datos-socio-casos">{{socioPendiente?.nombre | uppercase}}</b>
                        </div>
                        <br>
                    </div>
                </mat-panel-title>
                <mat-panel-description>
                    <div>
                        <!--======ok menu ======-->
                        <img *ngIf="okSocioDos" class="img-accordion" src="assets/icons/icon-check.svg" alt="ok" />
                    </div>
                    </mat-panel-description>
            </mat-expansion-panel-header>

         <!-- INICIO EVALUACION DE SOCIOS 2 ACCORDION -->
            <ng-container [formGroup]="datosCiAccordionForm" *ngIf="visualizarEvaluacionAccordion && dosSociosFC">
                <div class="row">
                    <app-messages *ngIf="visualizarEvaluacionAccordion" class="informativoSS mt-16 mb-16 p-16"
                    message='<strong>Importante:</strong> <b>La información de la empresa y de sus socios ha sido verificada por Transbank S.A.</b> en el Registro de Tu Empresa en un Día 
                    del Ministerio de Economía, Fomento y Turismo del Gobierno de Chile.'></app-messages>
                
                    <div class="col-md-6 m-top-24">
                        <label for="rut">RUT Socio(a)</label>
                        <input appFormatRut [readonly]="(datosCiAccordionForm.get('txtRut') || '') !== ''" type="text" name="txtRut" formControlName="txtRut" id="txtRut"
                            placeholder="Ej: 123456789"
                            [class.inputInvalido]="datosCiAccordionForm.get('txtRut').invalid && datosCiAccordionForm.get('txtRut').dirty"
                            autocomplete="off">
                        <div *ngFor="let validation of messageRescatarDataError.rutSocio">
                            <p *ngIf="datosCiAccordionForm.get('txtRut').hasError(validation.type) && (datosCiAccordionForm.get('txtRut').dirty || datosCiAccordionForm.get('txtRut').touched )"
                                class="mensajeError mb-0">
                                {{ validation.message }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 m-top-24 numero-serie" *ngIf="true">
                        <label for="txtSerie">Número de serie o documento </label>
                        <div class="label-right" (click)="modalCiHelper()">Info &nbsp;<i class="informativo-blue"></i></div>
                        <input appFormatSerie type="text" name="txtSerie" formControlName="txtSerie" placeholder="Ej: 123.456.789 o A01010101"
                            [class.inputInvalido]="datosCiAccordionForm.get('txtSerie').invalid && datosCiAccordionForm.get('txtSerie').dirty"
                            id="txtSerie" autocomplete="off">
                        <div *ngFor="let validation of messageRescatarDataError.serieSocio">
                            <p *ngIf="datosCiAccordionForm.get('txtSerie').hasError(validation.type) && (datosCiAccordionForm.get('txtSerie').dirty || datosCiAccordionForm.get('txtSerie').touched )"
                                class="mensajeError mb-0">
                                {{ validation.message }}
                            </p>
                        </div>
                    </div>

                    <div class="col-md-12 m-top-36">
                        <button tabindex="5" class="btn-primary-tbk button-float-right" type="submit" value="validarSocioDos"
                            (click)="validarSocioDos($event)" [disabled]="rutControlAccordion.invalid || serieControlAccordion.invalid">
                            <div *ngIf="loading" class="spinner-border text-light" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <div *ngIf="!loading">Evaluar</div>
                        </button>
                    </div>
                </div>
            </ng-container>
        <!-- FIN EVALUACION DE SOCIO 2 -->

        <!-- INICIO FORMULARIO DATOS SOCIO 2-->
        <ng-container [formGroup]="datosSocioDosForm" *ngIf="dosSociosFC && visualizarSocioDosAccordion">
            <div class="row">
                <div class="col-md-12">
                    <div class="datos-socios">
                        <ng-container>
                            <div class="row">
                                <div class="col-md-6 m-top-36">
                                    <label for="run">RUT Socio(a)</label>
                                    <input appFormatRut [readonly]="(datosSocioDosForm.get('run') || '') !== ''" type="text"
                                        name="run" formControlName="run" id="run" placeholder="Ej: 123456789"
                                        autocomplete="off" appMaxLength="12" [class.inputInvalido]="
                                        datosSocioDosForm.get('run').invalid && 
                                        datosSocioDosForm.get('run').touched
                                    " required />
                                    <div *ngFor="let validation of messageRescatarDataError.rutSocio">
                                        <p *ngIf="datosSocioDosForm.get('run').hasError(validation.type) && (datosSocioDosForm.get('run').dirty || datosSocioForm.get('run').touched )"
                                            class="mensajeError mb-0">
                                            {{ validation.message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 m-top-36">
                                    <label for="nombre">Nombre</label>
                                    <input appCaracteres [readonly]="
                                        (datosPersonalesSocioDosResponse?.nombre.nombres || '') !== ''
                                    " type="text" name="nombre" formControlName="nombre" placeholder="Ingresa nombre"
                                        autocomplete="off" appMaxLength="50" [class.inputInvalido]="
                                        datosSocioDosForm.get('nombre').invalid &&
                                        datosSocioDosForm.get('nombre').touched
                                    " required />
                                    <p *ngIf="
                                        (datosSocioDosForm.get('nombre').touched &&
                                        datosSocioDosForm.get('nombre') === null) ||
                                        (datosSocioDosForm.get('nombre').touched &&
                                        datosSocioDosForm.get('nombre').invalid)
                                    " class="mensajeError">
                                        {{ mensajeErrorDatosPersonales.REQUIRED_NAME_MESSAGE }}
                                    </p>
                                </div>
                                <div class="col-md-6 m-top-36">
                                    <label for="primerApellido">Primer apellido</label>
                                    <input appCaracteres [readonly]="
                                        (datosPersonalesSocioDosResponse?.nombre.apellidoPaterno || '') !== ''
                                    " type="text" name="primerApellido" formControlName="primerApellido"
                                        placeholder="Ingresa primer apellido" autocomplete="off" appMaxLength="50"
                                        [class.inputInvalido]="
                                        datosSocioDosForm.get('primerApellido').invalid &&
                                        datosSocioDosForm.get('primerApellido').touched
                                    " required />
                                    <p *ngIf="
                                        (datosSocioDosForm.get('primerApellido').touched &&
                                        datosSocioDosForm.get('primerApellido') === null) ||
                                        (datosSocioDosForm.get('primerApellido').touched &&
                                        datosSocioDosForm.get('primerApellido').invalid)
                                    " class="mensajeError">
                                        {{ mensajeErrorDatosPersonales.REQUIRED_LASTNAME_MESSAGE }}
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 m-top-36">
                                    <label for="segundoApellido">Segundo apellido (opcional)</label>
                                    <input appCaracteres [readonly]="
                                        (datosPersonalesSocioDosResponse?.nombre.apellidoMaterno || '') !== ''
                                    " type="text" name="segundoApellido" formControlName="segundoApellido"
                                        placeholder="Ingresa segundo apellido" appMaxLength="50" autocomplete="off" />
                                </div>
                                <!-- Existen dos DIV de nacionalidad ya que el disabled lógico no lo detecta -->
                                <div class="col-md-6 m-top-36">
                                    <label for="nacionalidad">Nacionalidad</label>
                                    <ng-container
                                        *ngIf="datosPersonalesSocioDosResponse?.idNacionalidad === 47; else selectHabilitado">
                                        <select name="nacionalidad" formControlName="nacionalidad" disabled>
                                            <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                                                {{ nacionalidad.nombre }}
                                            </option>
                                        </select>
                                    </ng-container>
                                    <ng-template #selectHabilitado>
                                        <select name="nacionalidad" formControlName="nacionalidad"
                                            [class.selectInvalido]="datosSocioDosForm.get('nacionalidad').invalid && datosSocioDosForm.get('nacionalidad').touched"
                                            placeholder="Seleccionar">
                                            <option value="0">Seleccionar</option>
                                            <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                                                {{ nacionalidad.nombre }}
                                            </option>
                                        </select>
                                    </ng-template>
                                    <p *ngIf="
                                        (datosSocioDosForm.get('nacionalidad').touched && datosSocioDosForm.get('nacionalidad') === null) ||
                                        (datosSocioDosForm.get('nacionalidad').touched && datosSocioDosForm.get('nacionalidad').invalid)G"
                                        class="mensajeError">
                                        {{ mensajeErrorDatosPersonales.REQUIRED_COUNTRY_MESSAGE }}
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 m-top-36">
                                    <label for="telefono">Teléfono</label>
                                    <span class="prefijo">+56</span>
                                    <input appNumeros type="text" class="pre-input" name="telefono"
                                        formControlName="telefono" placeholder="Ingresar hasta 9 digitos" autocomplete="off"
                                        appMaxLength="9" [class.inputInvalido]="
                                        datosSocioDosForm.get('telefono').invalid &&
                                        (datosSocioDosForm.get('telefono').touched || datosSocioDosForm.get('telefono').dirty)
                                    " required />
                                    <p *ngIf="
                                        (datosSocioDosForm.get('telefono').touched || datosSocioDosForm.get('telefono').dirty) &&
                                        ( datosSocioDosForm.get('telefono').hasError('length') || datosSocioDosForm.get('telefono').hasError('pattern') )
                                    " class="mensajeError">
                                        {{ mensajeErrorDatosPersonales.INVALID_PHONE_MESSAGE }}
                                    </p>
                                    <p *ngIf="
                                        (datosSocioDosForm.get('telefono').touched || datosSocioDosForm.get('telefono').dirty) &&
                                        datosSocioDosForm.get('telefono').hasError('required')
                                    " class="mensajeError">
                                        {{ mensajeErrorDatosPersonales.REQUIRED_PHONE_MESSAGE }}
                                    </p>
                                </div>
                            </div>
                            <app-messages *ngIf="showInfoMessage2" class="advertencia mt-48 mb-16 p-16" message='Por favor, <strong>verifica y completa los datos que falten</strong>.'>
                            </app-messages>
                            <div class="row box-button">
                                <div class="col-md-12">
                                    <button *ngIf="bloqueaBotonGuardarSocio2" class="btn-primary-tbk" type="submit" (click)="GuardarSocio2()"
                                        [disabled]=true>
                                        <div *ngIf="loading" class="spinner-border text-light" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <div *ngIf="!loading">Confirmar</div>
                                    </button>
                                    <button *ngIf="!bloqueaBotonGuardarSocio2" class="btn-primary-tbk" type="submit" (click)="GuardarSocio2()"
                                        [disabled]="!datosSocioDosForm.valid && !formChanged">
                                        <div *ngIf="loading" class="spinner-border text-light" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <div *ngIf="!loading">Confirmar</div>
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- FIN FORMULARIO DATOS SOCIO 2 -->
    </mat-expansion-panel>
</mat-accordion>
<!--FIN ACORDION SOCIOS-->
    <div class="row">
       <app-messages *ngIf="dosSociosFC && bloqueaBotonGuardarSocio2" class="informativoSS mt-48 mb-16 p-16" message='Luego de crear la cuenta
            en el Portal de Clientes Transbank, podrás agregar o cambiar el socio administrador, en el caso que lo requieras.'>
        </app-messages>
        <div class="row box-button" *ngIf="dosSociosFC && bloqueaBotonGuardarSocio2">
            <div class="col-md-12">
                <button class="btn-primary-tbk" type="submit" value="ContinuarDosSocios" (click)="ContinuarDosSocios()">
                    <div>Continuar</div>
                </button>
            </div>
        </div>
    </div>

    <div class="row"
        *ngIf="!agregandoSocio && contadorSociosIngresados > 0 && contadorSociosIngresados!=cantidadRepresentantesMax && flujoNormal">
        <div class="col-md-12">
            <button class="btn-add-socio"
                [disabled]="agregandoSocio || contadorSociosIngresados==0 || contadorSociosIngresados==cantidadRepresentantesMax"
                (click)="AgregarOtroSocio()"> Agregar otro socio</button>
        </div>
    </div>
    <div class="row box-button" *ngIf="!agregandoSocio && contadorSociosIngresados > 0 && flujoNormal">
        <div class="col-md-12">
            <!-- (click)="Continuar($event)" -->
            <button class="btn-primary-tbk" type="submit" value="Continuar" (click)="Continuar()"
                [disabled]="agregandoSocio || contadorSociosIngresados==0 || !isThereAnEmailRRLL">
                <div *ngIf="loading" class="spinner-border text-light" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div *ngIf="!loading">Continuar</div>
            </button>
            <app-messages *ngIf="agregandoSocio || contadorSociosIngresados==0 || !isThereAnEmailRRLL" class="advertencia mt-48 mb-16 p-16" message='Por favor ingrese el correo de un RRLL'>
            </app-messages>
        </div>
    </div>
</mat-expansion-panel>